import axios from 'axios'
import qs from 'qs'

import { applyAccessToken, applyMultiStatusError, applyErrorNotification, applyUnauthorized } from './interceptors'

import type { AxiosInstance, CreateAxiosDefaults, CustomParamsSerializer } from 'axios'

const host = window.location.hostname

export const API_URL = host.endsWith('lenta.com') ? `https://api-${host}` : process.env.REACT_APP_BASE_URL ?? ''
export const SAML_PATH = process.env.REACT_APP_SAML_PATH ?? 'saml2/login/'

const applyInterceptors = (api: AxiosInstance): void => {
  applyErrorNotification(api)
  applyMultiStatusError(api)
  applyAccessToken(api)
  applyUnauthorized(api)
}

const headers: CreateAxiosDefaults['headers'] = {
  accept: 'application/json',
  'Content-Type': 'application/json'
}

const serialize: CustomParamsSerializer = params => qs.stringify(params, { arrayFormat: 'comma' })

const config: CreateAxiosDefaults = {
  baseURL: API_URL,
  headers,
  paramsSerializer: { serialize }
}

const api: AxiosInstance = axios.create(config)

applyInterceptors(api)

export default api
